type FactSetOAuthReconnectHandler = () => Promise<void>;

let reconnectHandler: FactSetOAuthReconnectHandler | null = null;

export function registerFactSetOAuthReconnectHandler(
  handler: FactSetOAuthReconnectHandler,
): () => void {
  reconnectHandler = handler;
  return () => {
    if (reconnectHandler === handler) {
      reconnectHandler = null;
    }
  };
}

export async function forceReconnectFactSetOAuth(): Promise<void> {
  if (!reconnectHandler) {
    throw new Error("FactSet OAuth reconnect is not available in this host.");
  }

  await reconnectHandler();
}
